var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(item.icon),expression:"item.icon"}],attrs:{"src":item.icon}}),_c('span',{class:{ 'ml-10': item.icon }},[_vm._v(_vm._s(item.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }